// @flow
import React from "react";

import SelecaoRadioBaseComTraducao from "../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarFormaAcumulacao,
  getFormaAcumulacaoSelecionada,
  getFormasAcumulacao,
} from "../../../../state";

export default function SelecaoFormaAcumulacao() {
  return (
    <div className="ConfiguracaoMedida">
      <SelecaoRadioBaseComTraducao
        chaveTraducaoNomeSelecao={"ConfiguracaoIndicador.formaAcumulacao"}
        itensSelector={getFormasAcumulacao}
        selectorItemSelecionado={getFormaAcumulacaoSelecionada}
        onItemChange={selecionarFormaAcumulacao}
        campoId="codigo"
        campoChaveTraducao="descricao"
      />
    </div>
  );
}
